<template>
  <div class="backdrop"
       :class="{ background: isBackgroundRequired }"
       @click="close">
  </div>
</template>

<script>
  export default {
    name: 'Backdrop',
    props: {
      isBackgroundRequired: Boolean
    },
    data () {
      return {
      }
    },
    methods: {
      close () {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styling/styling.scss';

div {

  &.backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 800;
    font-size: 0;
  }

  &.background {
    background: black;
    opacity: 0.3;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Backdrop.vue